export default function RiskMonitoringAndTesting(
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
  editCustomTestingProceduresDialog
) {
  const vm = this;

  vm.canExpand = vm.assessmentCustomTestProcedure && vm.assessmentCustomTestProcedure.description;
  vm.isExpanded = false;

  vm.handleExpand = _handleExpand;
  vm.handleEditCustomTestingProcedures = _handleEditCustomTestingProcedures;
  vm.statusComplete = _statusComplete;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initPermissions();
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _handleExpand() {
    if (vm.canExpand) {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _statusComplete() {
    return vm.assessmentCustomTestProcedure && vm.assessmentCustomTestProcedure.description;
  }

  function _handleEditCustomTestingProcedures($event) {
    _loadCustomTestingProcedures().then(() => _openEditCustomTestingProceduresDialog($event, {
      assessmentId: vm.assessmentId,
      procedures: vm.assessmentCustomTestProcedure,
    }));
  }

  /** *********************************************
   * Private Functions
   */
  function _loadCustomTestingProcedures() {
    loaderService.showViewLoader = true;
    return bcpDataService.getCustomTestProcedures(vm.assessmentId)
      .then((response) => {
        vm.assessmentCustomTestProcedure = response.data;
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _openEditCustomTestingProceduresDialog($event, locals) {
    ssDialogService.dialogs.bcp.editCustomTestingProceduresDialog = ssDialogService.alert(
      editCustomTestingProceduresDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editCustomTestingProceduresDialog);
  }
}

RiskMonitoringAndTesting.$inject = [
  'bcpDataService',
  'loaderService',
  'ssDialogService',
  'userService',
  'editCustomTestingProceduresDialog'
];
